<div class="container-fluid complyon-page exceptions-page px-3 px-md-4 px-xl-4 py-3">
  <div class="complyon-shell exceptions-shell mx-auto">
    <section class="mb-3">
      <h1 class="complyon-title exceptions-title mb-2 text-l">Exceptions &amp; deviations</h1>
      <p class="complyon-subtitle exceptions-subtitle mb-0 text-s">
        Every approved departure from normal policy or procedure - emergency procurement, sole-source, payment and policy exceptions - with reason, approver, value and audit trail.
      </p>
    </section>

    <section class="row g-3 mb-3">
      <div v-for="card in summary_cards" :key="card.label" class="col-12 col-md-6 col-xl-3">
        <article class="complyon-card exceptions-card rounded-4 p-3 h-100">
          <div class="exceptions-stat-label text-xs">{{ card.label }}</div>
          <div class="exceptions-stat-value" :class="`is-${card.tone}`">{{ card.value }}</div>
          <div class="exceptions-stat-note text-xs">{{ card.note }}</div>
        </article>
      </div>
    </section>

    <section class="complyon-panel exceptions-panel rounded-4 overflow-hidden">
      <div class="d-flex flex-column flex-xl-row align-items-xl-start justify-content-between gap-3 px-3 px-md-4 pt-3 pt-md-4 pb-3">
        <div>
          <div class="exceptions-section-title text-s">Exceptions &amp; deviations register</div>
          <div class="exceptions-section-subtitle text-xs">Every approved departure from normal policy or procedure - emergency procurement, sole-source, payment exceptions, policy overrides - with the reason, approver, value and audit trail, so exceptions never disappear into email.</div>
        </div>
        <button type="button" class="btn config-navbar-primary-action d-inline-flex align-items-center gap-2">
          <i class="bi bi-plus"></i>
          <span>Log exception</span>
        </button>
      </div>

      <div class="d-flex flex-column flex-xl-row align-items-xl-center justify-content-between gap-3 px-3 px-md-4 pb-3">
        <div class="d-inline-flex flex-wrap align-items-center gap-1 exceptions-tab-bar rounded-4 p-1">
          <button v-for="tab in tabs" :key="tab.id" type="button" class="btn exceptions-tab-btn d-inline-flex align-items-center gap-2" :class="{ active: active_tab === tab.id }" @click="set_tab(tab.id)">
            <span>{{ tab.label }}</span>
            <span class="exceptions-tab-count">{{ tab.count }}</span>
          </button>
        </div>

        <div class="exceptions-search-wrap position-relative">
          <i class="bi bi-search exceptions-search-icon"></i>
          <input v-model="search_query" type="search" class="form-control exceptions-search-input" placeholder="Search..." aria-label="Search exceptions">
        </div>
      </div>

      <div class="table-responsive">
        <table class="table complyon-table exceptions-table align-middle mb-0">
          <thead>
            <tr>
              <th class="ps-3 text-xs">Ref</th>
              <th class="text-xs">Exception</th>
              <th class="text-xs">Type</th>
              <th class="text-xs">Value</th>
              <th class="text-xs">Approved by</th>
              <th class="text-xs">Status</th>
              <th class="text-xs"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="row in filtered_rows"
              :key="row.ref"
              class="exceptions-row"
              role="button"
              tabindex="0"
              @click="open_exception_drawer(row)"
              @keydown.enter.prevent="open_exception_drawer(row)"
              @keydown.space.prevent="open_exception_drawer(row)"
            >
              <td class="ps-3 fw-semibold text-nowrap">{{ row.ref }}</td>
              <td class="fw-semibold">{{ row.exception }}</td>
              <td>{{ row.type }}</td>
              <td class="fw-semibold">{{ row.value }}</td>
              <td>{{ row.approved_by }}</td>
              <td><span class="badge rounded-pill exceptions-pill text-xs" :class="row.status_class">{{ row.status }}</span></td>
              <td class="text-end pe-3"><i class="bi bi-chevron-right exceptions-row-arrow"></i></td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>

  <div
    v-if="active_exception_drawer"
    class="command-centre-drawer-backdrop"
    @click="close_exception_drawer"
  >
    <aside
      class="command-centre-drawer exceptions-drawer"
      role="dialog"
      aria-modal="true"
      :aria-label="active_exception_drawer.title"
      @click.stop
    >
      <header class="command-centre-drawer-header border-bottom">
        <div class="d-flex align-items-start justify-content-between gap-3">
          <div class="min-w-0">
            <div class="exceptions-drawer-kicker text-uppercase">{{ active_exception_drawer.kicker }}</div>
            <div class="command-centre-drawer-title mt-1">{{ active_exception_drawer.title }}</div>
            <div class="command-centre-drawer-subtitle mt-1">{{ active_exception_drawer.subtitle }}</div>
          </div>
          <div class="d-flex align-items-center gap-2 flex-shrink-0">
            <span class="badge rounded-pill exceptions-pill text-xs" :class="active_exception_drawer.status_class">{{ active_exception_drawer.status }}</span>
            <button type="button" class="btn btn-link p-0 exceptions-drawer-close" @click="close_exception_drawer" aria-label="Close drawer">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>
        </div>
      </header>

      <div class="command-centre-drawer-body">
        <section class="mb-3">
          <div class="row g-2 exceptions-drawer-stats">
            <div class="col-6">
              <div class="exceptions-drawer-stat rounded-3 p-3 h-100">
                <div class="exceptions-drawer-stat-label">Result</div>
                <div class="exceptions-drawer-stat-value">{{ active_exception_drawer.status }}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="exceptions-drawer-stat rounded-3 p-3 h-100">
                <div class="exceptions-drawer-stat-label">Value</div>
                <div class="exceptions-drawer-stat-value">{{ active_exception_drawer.value }}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="exceptions-drawer-stat rounded-3 p-3 h-100">
                <div class="exceptions-drawer-stat-label">Approved by</div>
                <div class="exceptions-drawer-stat-value">{{ active_exception_drawer.approver }}</div>
              </div>
            </div>
            <div class="col-6">
              <div class="exceptions-drawer-stat rounded-3 p-3 h-100">
                <div class="exceptions-drawer-stat-label">{{ active_exception_drawer.expiry ? 'Next due' : 'Status note' }}</div>
                <div class="exceptions-drawer-stat-value">{{ active_exception_drawer.expiry || active_exception_drawer.status_note }}</div>
              </div>
            </div>
          </div>
        </section>

        <section class="mb-3">
          <div class="exceptions-drawer-detail-grid">
            <div class="exceptions-drawer-detail-label">Exception</div>
            <div class="exceptions-drawer-detail-value">{{ active_exception_drawer.type }}</div>
            <div class="exceptions-drawer-detail-label">Reason</div>
            <div class="exceptions-drawer-detail-value">{{ active_exception_drawer.reason }}</div>
            <div class="exceptions-drawer-detail-label">Value</div>
            <div class="exceptions-drawer-detail-value">{{ active_exception_drawer.value }}</div>
            <div class="exceptions-drawer-detail-label">Approver</div>
            <div class="exceptions-drawer-detail-value">{{ active_exception_drawer.approver }}</div>
            <div v-if="active_exception_drawer.expiry" class="exceptions-drawer-detail-label">Expiry</div>
            <div v-if="active_exception_drawer.expiry" class="exceptions-drawer-detail-value">{{ active_exception_drawer.expiry }}</div>
            <div class="exceptions-drawer-detail-label">Status</div>
            <div class="exceptions-drawer-detail-value">{{ active_exception_drawer.status_note }}</div>
          </div>
        </section>

        <section v-if="active_exception_drawer.checks.length" class="mb-3">
          <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
            <div class="command-centre-drawer-section-title">Evidence &amp; checks</div>
            <span class="badge rounded-pill exceptions-drawer-alert">{{ active_exception_drawer.checks_alert }}</span>
          </div>
          <div class="d-flex flex-column gap-2">
            <div v-for="check in active_exception_drawer.checks" :key="check.title" class="exceptions-check-card rounded-3 p-3">
              <div class="d-flex align-items-start justify-content-between gap-3">
                <div class="d-flex align-items-start gap-2 min-w-0">
                  <span class="command-centre-drawer-item-icon" :class="drawer_tone_class(check.tone)">
                    <i class="bi" :class="check.tone === 'red' ? 'bi-x-lg' : 'bi-exclamation-lg'"></i>
                  </span>
                  <div class="min-w-0">
                    <div class="command-centre-drawer-item-title">{{ check.title }}</div>
                    <div class="command-centre-drawer-item-subtitle">{{ check.status }}</div>
                  </div>
                </div>
                <span class="badge rounded-pill exceptions-pill text-xs" :class="check.tone === 'red' ? 'bg-danger-subtle text-danger-emphasis' : 'bg-warning-subtle text-warning-emphasis'">{{ check.status }}</span>
              </div>
            </div>
          </div>
        </section>

        <section v-if="active_exception_drawer.connected_records.length" class="mb-3">
          <div class="command-centre-drawer-section-title mb-2">Connected records</div>
          <div class="row g-2">
            <div v-for="record in active_exception_drawer.connected_records" :key="`${record.type}-${record.title}`" class="col-12 col-sm-6">
              <div class="command-centre-drawer-item h-100">
                <div class="d-flex align-items-start justify-content-between gap-2">
                  <div class="d-flex align-items-start gap-2 min-w-0">
                    <span class="command-centre-drawer-item-icon" :class="drawer_tone_class(record.tone)">
                      <i class="bi" :class="record.icon"></i>
                    </span>
                    <div class="min-w-0">
                      <div class="exceptions-record-type text-uppercase">{{ record.type }}</div>
                      <div class="command-centre-drawer-item-subtitle">{{ record.title }}</div>
                    </div>
                  </div>
                  <i class="bi bi-box-arrow-up-right exceptions-record-arrow"></i>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section class="mb-3">
          <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
            <div class="command-centre-drawer-section-title">Recommended action</div>
            <span class="badge rounded-pill exceptions-drawer-ai">AI</span>
          </div>
          <div class="exceptions-recommendation rounded-4 p-3">
            {{ active_exception_drawer.recommendation }}
          </div>
        </section>
      </div>

      <footer class="command-centre-drawer-footer border-top">
        <div class="d-flex align-items-center justify-content-between gap-3">
          <button type="button" class="btn btn-link text-decoration-none px-0 exceptions-watch-btn">
            <i class="bi bi-flag me-1"></i>
            <span>Watch</span>
          </button>
          <div class="d-flex align-items-center gap-2">
            <button
              v-for="action in active_exception_drawer.footer_actions"
              :key="action.label"
              type="button"
              :class="footer_button_class(action.style)"
            >
              <span>{{ action.label }}</span>
            </button>
          </div>
        </div>
      </footer>
    </aside>
  </div>
</div>
